import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useProvider } from 'src/state/provider';
import { useHeaderMenu } from 'src/state/headerMenu';
import { useDashboard } from 'src/state/dashboard';

const StyledProviderDrawerLabel = styled('span', {
  verticalAlign: 'middle',
  display: 'inline-block',
  color: '$gray8',
  fontSize: '16px',
  fontWeight: 'bold',
});

const StyledProviderSelectButton = styled(Button, {
  '&.abyss-button-root': {
    paddingLeft: 0,
    fontSize: 14,
    height: 'auto',
    boxShadow: 'none !important',
  },
  '.abyss-insert-element-after': {
    paddingLeft: '6px !important',
  },
});

const StyledServicingProviderLabel = styled('span', {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '250px',
  fontSize: '16px',
  fontWeight: 'bold',
});

const StyledProviderContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
});

export const ProviderSelectDrawer = ({ providerNotSaved }) => {
  const { provider } = useProvider.state();
  const { toggleProvider } = useHeaderMenu.actions();
  const { providerPreferenceComplete, providerPreferenceError } =
    useDashboard.state();

  const isProviderPreferenceError =
    Object.keys(providerPreferenceError).length !== 0;

  const handleProviderButtonClick = () => {
    toggleProvider(true);
  };

  return (
    <React.Fragment>
      <StyledProviderContainer>
        <StyledProviderDrawerLabel>Provider</StyledProviderDrawerLabel>
        <StyledProviderSelectButton
          data-testid="provider-select-drawer-button"
          isLoading={!providerPreferenceComplete}
          onClick={handleProviderButtonClick}
          variant="tertiary"
          after={
            <IconSymbol icon="keyboard_arrow_right" color="$interactive1" />
          }
        >
          <Choose>
            <When condition={providerNotSaved || isProviderPreferenceError}>
              <StyledServicingProviderLabel data-testid="provider-label-provider-not-saved">
                Unavailable
              </StyledServicingProviderLabel>
            </When>
            <Otherwise>
              <StyledServicingProviderLabel data-testid="provider-label">
                {provider.servicingProviderName || 'Loading Provider...'}
              </StyledServicingProviderLabel>
            </Otherwise>
          </Choose>
        </StyledProviderSelectButton>
      </StyledProviderContainer>
    </React.Fragment>
  );
};

ProviderSelectDrawer.propTypes = {
  setDigitalSecurityError: PropTypes.func,
};

ProviderSelectDrawer.defaultProps = {
  setDigitalSecurityError: () => {},
};
